import type { Direction } from "../../../engine/direction";
import { BurstParticle } from "./burstParticle";

export class WoodDebrisParticle extends BurstParticle {
	constructor(originX: number, originY: number, direction?: Direction) {
		super(
			originX,
			originY,
			{
				ttl: [300, 500],
				size: [0.45, 0.25],
				color: { r: 223, g: 157, b: 0 },
				speed: [1.5, 3.0],
				gravity: 5.0,
			},
			direction,
		);
	}
}
